import { ImpersonateOnlyIcon, InvitationIcon, NoProfileIcon, ProfileIcon } from '@bp/ui-components';
import i18next from 'i18next';
import { ReactNode } from 'react';

export function getUserStatusTranslation(status: string): string {
  switch (status) {
    case 'none':
      return i18next.t('userStatus.none');
    case 'invited':
      return i18next.t('userStatus.invited');
    case 'impersonateOnly':
      return i18next.t('userStatus.impersonateOnly');
    case 'full':
      return i18next.t('userStatus.full');
    default:
      return status;
  }
}

export function getUserStatusAsIcon(status: string): ReactNode {
  switch (status) {
    case 'none':
      return <NoProfileIcon color='var(--color-grey-lighter)' />;
    case 'invited':
      return <InvitationIcon />;
    case 'impersonateOnly':
      return <ImpersonateOnlyIcon color='var(--color-grey-lighter)' />;
    case 'full':
      return <ProfileIcon />;
    default:
      return status;
  }
}
